import { React, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Alert from "@mui/material/Alert";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import api from '../../services/api';
import Loading from "../Layout/Loading";

function RevisaoBoleto(){

    //#region constantes
    const navigate = useNavigate();

    const location = useLocation();

    const [dadosGerais, setDadosGerais] = useState({});
    const [mesesSelecionados, setMesesSelecionados] = useState([]);
    
    const [showLoading, setShowLoading] = useState(false);

    // Objeto enviado no post
    const [dadosBoleto, setDadosBoleto] = useState({});

    const [valorBoleto, setValorBoleto] = useState(0);

    const [msgInfo, setMsgInfo] = useState("");
    const [msgAviso, setMsgAviso] = useState("");
    
    /* Constantes para controlar o foco do mouse nos botões */
    const [isHoverAvancar, setIsHoverAvancar] = useState(false);
    const [isHoverVoltar, setIsHoverVoltar] = useState(false);
    //#endregion 


    //#region handle mouse
    const handleMouseEnterAvancar = () => {
        setIsHoverAvancar(true);
    };

    const handleMouseLeaveAvancar = () => {
        setIsHoverAvancar(false);
    };

    const handleMouseEnterVoltar = () => {
        setIsHoverVoltar(true);
    };

    const handleMouseLeaveVoltar = () => {
        setIsHoverVoltar(false);
    };
    //#endregion
    


    //#region functions
    function Voltar(){

        navigate("/novoboleto", { state: dadosGerais });

    }

    function GerarBoleto(){

        /* Bloco para homolocação, dados de teste

        const boleto = {
            ID_BOLETO: 5487,
            VALOR_ORIGINAL: 175.85,
            VENCIMENTO: "15/10/2025",
            LINK_BOLETO: "https://www.troltech.com.br"
        }

        const dados = {
            dadosgerais: dadosGerais,
            boleto: boleto
        }

        navigate("/boleto", {state : dados});

        */


        setShowLoading(true);

        setTimeout(() => {

            api.post("cadastro/taxacusteio", dadosBoleto)
            .then((resp) => {

                const boleto = {
                    ID_BOLETO: resp.data.ID_BOLETO,
                    VALOR_ORIGINAL: resp.data.VALOR,
                    VENCIMENTO: resp.data.VENCIMENTO,
                    LINK_BOLETO: resp.data.LINK
                }

                const dados = {
                    dadosgerais: dadosGerais,
                    boleto: boleto
                }

                setShowLoading(false);

                navigate("/boleto", {state : dados});
                
            })
            .catch((err) => {

                setShowLoading(false);
                

            });



        }, 500);

    }
    //#endregion
    


    //#region useEffect
    useEffect(() => {

        setDadosGerais(location.state.dadosgerais);
        //console.log(location.state.dadosgerais);
        setMesesSelecionados(location.state.mesesselecionados);
        //console.log(location.state.mesesselecionados);

        // Soma o valor total do boleto
        const total = location.state.mesesselecionados.reduce((soma, valorAtual) => {
            return soma + valorAtual.VALOR_TOTAL;
        }, 0);
        setValorBoleto(total);

        // Se existir histórico de guias pagas com R.E. informadas (ao menos 3 guias pagas com re)...
        // 01 - Mostra a quantidade média de funcionários desta empresa (informação)
        // 02 - Caso a média informada para geração do boleto seja menor que 70% da 
        //      média acima, mostra mensagem informando e questionando se realmente deseja emitir o boleto (aviso)
        if(location.state.dadosgerais.HISTORICO_PAGAMENTOS_COM_RE.length > 2){

            let mediaHistorico = location.state.dadosgerais.HISTORICO_PAGAMENTOS_COM_RE.reduce((soma, valorAtual) => {
                return soma + valorAtual.QT_CONTRIBUINTES;
            }, 0);

            mediaHistorico = Math.trunc(mediaHistorico / 3);

            setMsgInfo(`Esta empresa informa em média ${mediaHistorico} contribuintes em cada relação.`);


            const mediaInformada = location.state.mesesselecionados.reduce((soma, valorAtual) => {
                return soma + valorAtual.QTDE_FUNCIONARIOS;
            }, 0);

            const percEntreMedias = Math.trunc(mediaInformada / mediaHistorico * 100);

            if(percEntreMedias < 70){
                setMsgAviso(`A quantidade informada de funcionários está muito abaixo da média desta empresa, tem certeza que deseja emitir o boleto mesmo assim?`);
            }

        }

        // Montando objeto final para envio no post
        let dados = {};

        dados.VALOR_BOLETO   = total;
        dados.ID_USUARIO     = 1;
        dados.ORIGEM_EMISSAO = 'I'; // I = INTERNET; N = NORMAL/SISTEMA GESTAO
        dados.TIPO_EMISSAO   = 'I'; // I = INDIVIDUAL; G = GERAL
        dados.EMPRESA        = location.state.dadosgerais.EMPRESA;
        dados.MESES          = location.state.mesesselecionados;

        setDadosBoleto(dados);

        //console.log(dados);

    }, []);
    //#endregion



    //#region html
    return (
        <div>
            {
                (Object.keys(dadosGerais).length > 0) ? (

                    <div className="form-control"
                        style={{padding:"10px 10px 0 10px",
                                textAlign:'center',
                                backgroundColor:'#fff',
                                height:'89.9vh',
                                overflow:'auto'}}>
                        {!showLoading ? (
                        <div className="form-control">
                        
                            <div className="cnpjcpf-content-container" 
                                    style={{backgroundColor:'#fff',
                                            marginBottom:'0.5rem'}}>

                                {/* Titulo */}
                                <div style={{fontSize:'24px',
                                                color:'#423c89',
                                                backgroundColor:'#fff',
                                                marginBottom:'0.5rem'}}>
                                    <h3>Revisão para emissão de boleto</h3>
                                </div>

                                {/* Corpo */}
                                <div style={{fontSize:'16px',
                                            backgroundColor:'#fff',
                                            marginBottom:'0.5rem'}}>
                                    
                                    {/* Dados da empresa */}
                                    <div style={{backgroundColor:'gray', 
                                                    width:'100%',
                                                    margin:'auto',
                                                    color:'white',
                                                    borderRadius:'0.5rem'}}>
                                        Dados da empresa
                                    </div>

                                    {/* CNPJ */}
                                    <div style={{textAlign:'left'}}>
                                        <span style={{fontWeight:'bold'}}>CNPJ:</span>
                                        <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.CNPJ}</span>
                                    </div>

                                    {/* NOME_FANTASIA */}
                                    <div style={{textAlign:'left'}}>
                                        <span style={{fontWeight:'bold'}}>Nome Fantasia:</span>
                                        <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.NOME_FANTASIA}</span>
                                    </div>

                                    {/* RAZAO_SOCIAL */}
                                    <div style={{textAlign:'left'}}>
                                        <span style={{fontWeight:'bold'}}>Razão social:</span>
                                        <span style={{marginLeft:'0.5rem'}}>{dadosGerais.EMPRESA.RAZAO_SOCIAL}</span>
                                    </div>


                                    {/* Mêses selecionados para pagametno */}
                                    <div style={{backgroundColor:'gray', 
                                                    width:'100%',
                                                    margin:'auto',
                                                    color:'white',
                                                    borderRadius:'0.5rem',
                                                    marginTop:'1rem'}}>
                                        Revise os dados e gere o boleto
                                    </div>

                                    <div style={{width:'300px',
                                                backgroundColor:'silver',
                                                margin:'auto',
                                                marginTop:'1rem',
                                                borderRadius:'0.5rem'}} >

                                        <div style={{fontWeight:'bold'}}>Boleto</div>
                                        <div>Quantidade de meses informados</div>
                                        <div style={{fontWeight:'bold',color: '#2957A4', fontSize:'2rem'}}>{mesesSelecionados.length}</div>
                                        <div style={{marginTop:'0.5rem'}}>Valor total do boleto</div>
                                        <div style={{fontWeight:'bold',color:'blue'}}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(valorBoleto)}</div>
                                       

                                        {/* DIV dos botões tdtoaki */}
                                        <div>

                                            {/* Voltar */}
                                            <div style={{backgroundColor: isHoverVoltar ? '#2957A4' : '#fff',
                                                        width:'100px', display:'inline-block',
                                                        height:'28px',
                                                        alignContent: 'center',
                                                        cursor:'pointer',
                                                        margin:'auto',
                                                        color: isHoverVoltar ? '#fff' : 'black',
                                                        marginRight:'5px',
                                                        borderRadius:'0.5rem',
                                                        borderWidth:'0.2rem',
                                                        borderStyle:'solid',
                                                        borderColor:'#2957A4',
                                                        marginTop:'1rem',
                                                        marginBottom:'1rem'}}
                                                onMouseEnter={handleMouseEnterVoltar}
                                                onMouseLeave={handleMouseLeaveVoltar}
                                                onClick={Voltar}>
                                                Voltar
                                            </div>

                                            {/* Gerar boleto */}
                                            <div style={{backgroundColor: isHoverAvancar ? '#0033EA' : '#2957A4',
                                                        width:'100px', display:'inline-block',
                                                        height:'28px',
                                                        alignContent: 'center',
                                                        cursor:'pointer',
                                                        margin:'auto',
                                                        color:'white',
                                                        borderRadius:'0.5rem',
                                                        borderWidth:'0.2rem',
                                                        borderStyle:'solid',
                                                        borderColor:isHoverAvancar ? '#0033EA' : '#2957A4', 
                                                        marginLeft:'5px',
                                                        marginTop:'1rem',
                                                        marginBottom:'1rem'}}
                                                onMouseEnter={handleMouseEnterAvancar}
                                                onMouseLeave={handleMouseLeaveAvancar}
                                                onClick={GerarBoleto}>
                                                Gerar boleto
                                            </div>
                                        </div>

                                        {
                                            (msgInfo) ? (
                                                <Alert icon={<InfoOutlineIcon />}
                                                        severity="info"
                                                        style={{width:'98%',
                                                                margin:'auto',
                                                                marginBottom:'1rem' }}>
                                                    {msgInfo}
                                                </Alert>

                                            ) : null
                                        }

                                        {
                                            (msgAviso) ? (
                                                <Alert icon={<WarningAmberIcon />}
                                                        severity="warning"
                                                        style={{width:'98%',
                                                                margin:'auto',
                                                                marginBottom:'1rem' }}>
                                                    {msgAviso}
                                                </Alert>

                                            ) : null
                                        }

                                        {/* Títulos */}
                                        <div style={{padding:'0.2rem',
                                                     width:'98%',
                                                     backgroundColor:'#fff',
                                                     margin:'auto',
                                                     borderRadius:'0.5rem',
                                                     marginBottom:'0.3rem',
                                                     fontWeight:'bold'}}>
                                            <div style={{display:'inline-block',textDecoration:'underline',width:'33.3%'}}>Mês de referência</div>
                                            <div style={{display:'inline-block',textDecoration:'underline',width:'33.3%'}}>Valor por funcionário</div>
                                            <div style={{display:'inline-block',textDecoration:'underline',width:'33.4%'}}>Nº de funcionários</div>
                                        </div>


                                        {
                                            mesesSelecionados.map((item, index) => (

                                                /* Card das referências */
                                                <div key={item.REFERENCIA}
                                                     style={{marginTop:'0.5rem',
                                                            width:'98%',
                                                            backgroundColor:'white',
                                                            height:'30px',
                                                            margin:'auto',
                                                            borderRadius:'0.5rem',
                                                            textAlign:'center',
                                                            padding:'0rem',
                                                            marginBottom:'0.3rem'}}>

                                                    {/* Referência/Valor/Qtde funcionários */}
                                                    <div style={{padding:'0.2rem'}}>

                                                        <div style={{display:'inline-block',backgroundColor:'#fff',width:'33.3%',fontWeight:'bold'}}>
                                                            {item.REFERENCIA_STR}
                                                        </div>
                                                        <div style={{display:'inline-block',backgroundColor:'#fff',width:'33.3%',fontWeight:'bold'}}>
                                                            {new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(item.VALOR_POR_EMPREGADO)}
                                                        </div>
                                                        <div style={{display:'inline-block',backgroundColor:'#fff',width:'33.3%',fontWeight:'bold'}}>
                                                            {item.QTDE_FUNCIONARIOS}
                                                        </div>

                                                    </div>
                                                </div>

                                            ))
                                        }

                                        <br />

                                    </div>

                                </div>

                            </div>
                        
                        </div>
                        ) :  <Loading />}
                    </div>

                ): (
                    <div>Carregando...</div>
                )
            }

        </div>
    )
    //#endregion

}

export default RevisaoBoleto;